import { render, staticRenderFns } from "./data-zhuce.vue?vue&type=template&id=b7d86d56&"
import script from "./data-zhuce.vue?vue&type=script&lang=js&"
export * from "./data-zhuce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports